import { Dialog } from '@2n/design-system';
import { Add as AddIcon, Done as DoneIcon } from '@mui/icons-material';
import { Box } from '@mui/material';
import { IDSModalBase } from '../designSystemUnexported';

export interface ICreateOrEditModalDialogData extends IDSModalBase {
  closeButtonDataTestId?: string;
  isEdit: boolean;
  submitDisabled?: boolean;
}

export function CreateOrEditModalDialog(data: ICreateOrEditModalDialogData) {
  // TODO: Remove this workaround once @2n/design-system Dialog supports closeButtonDataTestId prop
  const boxRefCallback = (node: HTMLDivElement | null) => {
    if (!node || !data.closeButtonDataTestId) return;
    const dialog = node.closest('[role="dialog"]');
    if (dialog) {
      const closeButton = dialog.querySelector('button[class*="IconButton"]');
      if (closeButton) {
        closeButton.setAttribute('data-testid', data.closeButtonDataTestId);
      }
    }
  };

  return (
    <Dialog
      footerOptions={{
        primaryButton:
          data.primaryButtonAction && data.primaryButtonText !== undefined
            ? {
                action: data.primaryButtonAction,
                dataTestId: data.primaryButtonDataTestId,
                icon: {
                  icon: data.isEdit ? <DoneIcon /> : <AddIcon />,
                  iconPosition: 'start',
                },
                isDisabled: data.submitDisabled ?? false,
                text: data.primaryButtonText,
              }
            : undefined,
        secondaryButton:
          data.secondaryButtonAction && data.secondaryButtonText
            ? {
                action: data.secondaryButtonAction,
                dataTestId: data.secondaryButtonDataTestId,
                text: data.secondaryButtonText,
                variant: 'text',
              }
            : undefined,
      }}
      hasBodyContentPadding={false}
      hideCloseButton={false}
      onClose={data.onClose}
      open={!!data.open}
      title={data.title}
    >
      <Box ref={boxRefCallback} data-testid={data.testId} sx={{ pt: 3, px: 3 }}>
        {data.children}
      </Box>
    </Dialog>
  );
}

export default CreateOrEditModalDialog;
